module.exports = san.defineComponent({
    template: require('../views/workAccidentDeath.html'),
    initData: function () {
        return {
            showFlag: 1,
            switchFlag: 1,
            caseList: [], //案例
            caseType: 2, //案例类型
            businessType: 4, //伤残类型
            disposableIncome: '',
            params: {
                averageWage: 5536, //地方平均工资（2016年浙江省）
                consumerSpending: 42359, //人均支配
                disposableIncome: 0, //生前工资
                deathTime: '2020', //事故发生时间
                level: 1, //伤残等级
                isPayInsurance: 1,
                deathType: '1', //事故发生情形
                isWorkerDeath: '1', //是否因工伤死亡
                isWorkerElder: '1',  //配偶是否属于孤寡老人
                isHaveSpouse: '2', //是否有配偶
                isHaveOtherFanily: '2',  //是否有其他供养亲属
                specialSpouseside: '1',  //配偶情况
                specialFamilyside: '1',  //其他供养亲属情况
                otherFanilyNum: 1, //其他供养亲属人数
                otherFanilyElderNum: 0,  //其他供养亲属属于孤寡老人的人数
                medical: 0,//抢救医疗费
                funeral: 0,//丧葬费
                tardy: 0,//家属误工费
                traffic: 0,//家属交通费、住宿费
            },
            result: {
                deathSubsidy: 0,//一次性工亡补助金 20*averageWage
                dependentsDamage: 0,//供养亲属抚恤金（每月）30 ，20 ，+10+10
                funeralDamage: 0,//丧葬补助金，6*averageWage
                medicalDamage: 0,//抢救医疗费
                trafficDamage: 0,//交通费、住宿费
                spousePension: 0,//供养配偶抚恤金（每月）
                kinPension: 0,//供养其他亲属抚恤金（每月）
            }
        };
    },
    components: {

    },
    created: function () {
        this.data.set('disposableIncome', parseFloat((this.data.get('params.averageWage') * 0.6)).toFixed(2));
    },
    reset: function () {
        this.data.set('showFlag', 1);
        this.data.set('disposableIncome', parseFloat((this.data.get('params.averageWage') * 0.6)).toFixed(2));
        this.data.set('params', {
            averageWage: 5536, //地方平均工资（2016年浙江省）
            consumerSpending: 42359, //人均支配
            disposableIncome: 0, //生前工资
            deathTime: '2020', //事故发生时间
            deathType: '1',
            level: 1,
            isPayInsurance: 1,
            isWorkerDeath: '1',
            isWorkerElder: '1',
            isHaveSpouse: '2',
            isHaveOtherFanily: '2',
            specialSpouseside: '1',
            specialFamilyside: '1',
            otherFanilyNum: 1,
            otherFanilyElderNum: 0,
            medical: 0,//抢救医疗费
            funeral: 0,//丧葬费
            tardy: 0,//家属误工费
            traffic: 0,//家属交通费、住宿费
        });
        this.data.set('result', {
            deathSubsidy: 0,//一次性工亡补助金 20*averageWage
            dependentsDamage: 0,//供养亲属抚恤金（每月）30 ，20 ，+10+10
            funeralDamage: 0,//丧葬补助金，6*averageWage
            medicalDamage: 0,//抢救医疗费
            trafficDamage: 0,//交通费、住宿费
            spousePension: 0,//供养配偶抚恤金（每月）
            kinPension: 0,//供养其他亲属抚恤金（每月）
        })
    },
    getDeathTime: function () {
        switch (this.data.get('params.deathTime')) {
            case '2020': this.data.set('params.averageWage', 5536);
                this.data.set('params.consumerSpending', 42359);
                break;
            case '2019': this.data.set('params.averageWage', 5536);
                this.data.set('params.consumerSpending', 39250.8);
                break;
            case '2018': this.data.set('params.averageWage', 5091.58);
                this.data.set('params.consumerSpending', 36396);
                break;
            case '2017': this.data.set('params.averageWage', 4698.75);
                this.data.set('params.consumerSpending', 33616);
                break;
            case '2016': this.data.set('params.averageWage', 4309.92);
                this.data.set('params.consumerSpending', 31195);
                break;
            default: this.data.set('params.averageWage', 5536);
                this.data.set('params.consumerSpending', 42359);
                break;
        }
    },
    count: function () {

        //一次性工亡补助金
        this.data.set('result.deathSubsidy', parseFloat(parseFloat(this.data.get('params.consumerSpending') * 20).toFixed(2)));

        //丧葬补助金
        this.data.set('result.funeralDamage', parseFloat(parseFloat(this.data.get('params.averageWage') * 6).toFixed(2)));

        //抢救医疗费，根据发票报销，自己填
        this.data.set('result.medicalDamage', parseFloat(parseFloat(this.data.get('params.medical')).toFixed(2)));

        //家属误工费
        this.data.set('result.tardyDamage', parseFloat(parseFloat(this.data.get('params.tardy')).toFixed(2)));

        //家属交通费、住宿费，自己填
        this.data.set('result.trafficDamage', parseFloat(parseFloat(this.data.get('params.traffic')).toFixed(2)));

        //本人缴费工资基数
        this.data.set('params.disposableIncome', this.data.get('disposableIncome'));
        if (this.data.get('params.disposableIncome') < parseFloat((this.data.get('params.averageWage') * 0.6).toFixed(2))) {
            this.data.set('params.disposableIncome', parseFloat((this.data.get('params.averageWage') * 0.6).toFixed(2)));
        }
        if (this.data.get('params.disposableIncome') > parseFloat((this.data.get('params.averageWage') * 3).toFixed(2))) {
            this.data.set('params.disposableIncome', parseFloat((this.data.get('params.averageWage') * 3).toFixed(2)));
        }

        //供养配偶抚恤金
        if (this.data.get('params.isHaveSpouse') == 1 && this.data.get('params.specialSpouseside') == 1) {
            this.data.get('params.isWorkerElder') == 1 ? this.data.set('result.spousePension', parseFloat(this.data.get('params.disposableIncome') * (50 / 100).toFixed(2))) :
                this.data.set('result.spousePension', parseFloat(this.data.get('params.disposableIncome') * (40 / 100).toFixed(2)));
        } else {
            this.data.set('result.spousePension', 0);
        }

        //供养其他亲属抚恤金
        if (this.data.get('params.isHaveOtherFanily') == 1 && this.data.get('params.specialFamilyside') == 1) {
            this.data.get('params.otherFanilyElderNum') > this.data.get('params.otherFanilyNum') ? this.data.set('params.otherFanilyElderNum', this.data.get('params.otherFanilyNum')) : this.data.set('params.otherFanilyElderNum', this.data.get('params.otherFanilyElderNum'));
            var familyCoefficient = this.data.get('params.otherFanilyNum') * 0.3 + this.data.get('params.otherFanilyElderNum') * 0.1;
            if (this.data.get('params.isHaveSpouse') == 1 && this.data.get('params.specialSpouseside') == 1) {
                if (this.data.get('params.isWorkerElder') == 1) {
                    familyCoefficient <= 0.5 ? this.data.set('result.kinPension', parseFloat(this.data.get('params.disposableIncome') * familyCoefficient.toFixed(2))) :
                        this.data.set('result.kinPension', parseFloat(this.data.get('this.params.disposableIncome') * 0.5.toFixed(2)));
                } else {
                    familyCoefficient <= 0.6 ? this.data.set('result.kinPension', parseFloat(this.data.get('params.disposableIncome') * familyCoefficient.toFixed(2))) :
                        this.data.set('result.kinPension', parseFloat(this.data.get('params.disposableIncome') * 0.6.toFixed(2)));
                }
            } else {
                familyCoefficient <= 1 ? this.data.set('result.kinPension', parseFloat(this.data.get('params.disposableIncome') * familyCoefficient.toFixed(2))) :
                    this.data.set('result.kinPension', parseFloat(parseFloat(this.data.get('params.disposableIncome')).toFixed(2)));
            }
        } else {
            this.data.set('result.kinPension', 0);
        }

        //死亡情形：即时工亡→有3停工留薪期内死亡：因工伤死亡→有3 其他原因死亡→无；停工留薪期满死亡：伤残等级：1-4级→有2 5-10级→无
        if ((this.data.get('params.deathType') == 2 && this.data.get('params.isWorkerDeath') == 2) || (this.data.get('params.deathType') == 3 && this.data.get('params.level') > 4)) {
            this.data.set('result.deathSubsidy', 0);
            this.data.set('result.spousePension', 0);
            this.data.set('result.kinPension', 0);
            this.data.set('result.funeralDamage', 0);
        }
        if (this.data.get('params.deathType') == 3 && this.data.get('params.level') <= 4) {
            this.data.set('result.deathSubsidy', 0);
        }

        //合计
        this.data.set('result.totalDamage', this.data.get('result.deathSubsidy') + this.data.get('result.funeralDamage') +
            this.data.get('result.medicalDamage') + this.data.get('result.tardyDamage') + this.data.get('result.trafficDamage'));

        for (var i in this.data.get('result')) {
            this.data.set('result.' + i, window.changeNum._formatNum(this.data.get('result.' + i) + ''));
        }


        this.data.set('showFlag', 2);

        this.dispatch('goScroll', $('.count')[0].offsetTop + 105);
    },
    createReport: function () {
        this.data.set('switchFlag', 2);
        this.dispatch('goTo', $('.createReport')[0].offsetTop);

        //获取案例接口
        var params = {
            caseType: this.data.get('caseType'),
            disabilityLevel: this.data.get('params.level')
        };
        var me = this;
        Api("post", "/api/calculation/v2/getCaseList", JSON.stringify(params)).then(function (response) {
            if (response) {
                me.data.set('caseList', response.caseList);
            }
        });

        var data = {
            userId: localStorage.sysUserId,
            calculationType: this.data.get('businessType'),
            sourceType: 2,
            sourceTerminalId: 1,
            calculationParams: this.data.get('params'),
            calculationResult: this.data.get('result'),
        };
        Api("post", "/api/calculation/v2/saveCalculationLog", JSON.stringify(data)).then(function (response) { });
    },
    createCort: function (t) {
        this.dispatch('createCort', t);
    },
    back: function (flag) {
        this.data.set('switchFlag', flag);
    },
    toggle: function (e) {
        var args = e.target || e.srcElement;
        args.value == 0 ? args.value = '' : args.value = args.value;
    },
    toggle2: function (e) {
        var args = e.target || e.srcElement;
        args.value == '' ? args.value = 0 : args.value = args.value;
        var num = Number(args.value);
        (isNaN(num)) ? args.value = 0 : args.value = args.value;
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/components/workAccidentDeath.js
// module id = 360
// module chunks = 1